import { useEffect, useRef, useState } from 'react';

const useScroll = () => {
  const ref = useRef<HTMLUListElement | null>(null);
  const [prevScrollHeight, setPrevScrollHeight] = useState<number | null>(null);
  const [isTop, setIsTop] = useState<boolean>(false);
  const [isBottom, setIsBottom] = useState<boolean>(false);

  const toScrollBottom = () => {
    const el = ref.current as HTMLUListElement;
    if (el) el.scrollTop = el.scrollHeight;
  };

  const toScrollPrev = () => {
    const el = ref.current as HTMLUListElement;
    if (el) el.scrollTop = el.scrollHeight - (prevScrollHeight || 0);
  };

  const getIsScroll = () => {
    const el = ref.current as HTMLUListElement;
    return el?.scrollHeight > el?.clientHeight || el?.scrollWidth > el?.clientWidth;
  };

  useEffect(() => {
    const el = ref.current;
    const observer = new MutationObserver(() => {
      if (isBottom) toScrollBottom();
    });

    if (el) observer.observe(el, { childList: true, subtree: true });

    return () => {
      if (el) observer.disconnect();
    };
  }, [isBottom]);

  useEffect(() => {
    const el = ref.current;

    const handleScroll = () => {
      if (el) {
        const isTop = el.scrollTop <= 0;
        const isBottom = el.scrollTop + el.clientHeight > el.scrollHeight - 10;
        setIsTop(isTop);
        setIsBottom(isBottom);

        if (isTop) {
          setPrevScrollHeight(el.scrollHeight);
        }
      }
    };

    if (el) el.addEventListener('scroll', handleScroll);
    return () => {
      if (el) el.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return {
    ref,
    isTop,
    isBottom,
    toScrollBottom,
    toScrollPrev,
    getIsScroll,
  };
};

export default useScroll;
